import "./footer.scss";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaTiktok,
} from "react-icons/fa";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer--container">
        <div className="col">
          <h3>about</h3>
          <p>
            Your premier destination for exceptional real estate solutions in
            Dubai. With a passion for excellence, we offer personalized
            solutions, unrivaled expertise, and a diverse portfolio of
            properties in the most coveted locations. Trust us to make your real
            estate journey seamless and rewarding.
          </p>
        </div>
        <div className="col">
          <h3>connect on social media</h3>
          <div className="social">
            <a href="">
              <FaFacebook className="icon" />
            </a>
            <a href="">
              <FaInstagram className="icon" />
            </a>
            <a href="">
              <FaTwitter className="icon" />
            </a>
            <a href="">
              <FaLinkedin className="icon" />
            </a>

            <a href="">
              <FaTiktok className="icon" />
            </a>
          </div>
        </div>
        <div className="col">
          <h3>contact us</h3>

          <div className="sub-col">
            <h4>email</h4>
            {/* <a href="mailto:sales@aspect-global.com">sales@aspect-global.com</a> */}
            <a href="mailto:admin@skylineelite.ae">admin@skylineelite.ae </a>

          </div>
          <div className="sub-col">
            <h4>phone</h4>
            {/* <a href="tel:+971552312811">+971 4 570 8788</a> */}
            <a href="tel:+971552312811">+971 55 231 2811</a>
          </div>
          <div className="sub-col">
            <h4>address</h4>
            {/* <p>Tower 5B, Al Safa Park Complex, Dubai - United Arab Emirates</p> */}
            <p>Office 603, Palace Tower,  Dubai Silicon Oasis 
            </p>
          </div>
        </div>
      </div>
      <span>© 2023 Skyline Elite Properties. All rights reserved.</span>
    </div>
  );
};

export default Footer;
